<template>
    <div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="image-294 form-rep">
                    </a>
                    <div class="form-nav-div" style="justify-content: center;">
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Verify Address</div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"></div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        <div v-if="loadingAddress || validatingAddress" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                    </circle>
                </svg>
            </div>
        </div>

        <section class="afterreport_section">
            <div class="questions-div">
                <div class="question-container">
                    <div class="question-div-2">
                        <div class="text-block-513 hq">Verify your shipping address</div>
                        <div class="form-subs">We need to confirm your shipping address to ensure accurate delivery of your medications.</div>

                        <!-- Show suggested address if there are corrections -->
                        <div v-if="showSuggestions && suggestedAddress" class="address-suggestions">
                            <div class="suggestion-header">We found a suggested correction for your address:</div>
                            <div class="comparison-container">
                                <div class="address-column">
                                    <div class="column-title">You Entered:</div>
                                    <div class="address-display">
                                        <div>{{ addressForm.address_line_1 }}</div>
                                        <div v-if="addressForm.address_line_2">{{ addressForm.address_line_2 }}</div>
                                        <div>{{ addressForm.city }}, {{ addressForm.state }} {{ addressForm.zip }}</div>
                                    </div>
                                </div>
                                <div class="address-column">
                                    <div class="column-title">Suggested Address:</div>
                                    <div class="address-display suggested">
                                        <div>{{ suggestedAddress.address_line_1 }}</div>
                                        <div v-if="suggestedAddress.address_line_2">{{ suggestedAddress.address_line_2 }}</div>
                                        <div>{{ suggestedAddress.city }}, {{ suggestedAddress.state }} {{ suggestedAddress.zip }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="button-group">
                                <button
                                    type="button"
                                    class="form-button w-button"
                                    @click="acceptSuggestion"
                                    :disabled="validatingAddress"
                                >
                                    Use Suggested Address
                                </button>
                                <button
                                    type="button"
                                    class="form-button secondary w-button"
                                    @click="editAddress"
                                >
                                    Edit Address
                                </button>
                            </div>
                        </div>

                        <div v-if="!loadingAddress && !showSuggestions" class="felix-form-block w-form">
                            <form @submit.prevent="validateAndSaveAddress">
                                <div class="address-form-row">
                                    <div class="address-field">
                                        <input
                                            class="tf_textfield-3 w-input"
                                            v-model="addressForm.address_line_1"
                                            maxlength="256"
                                            name="Address-1"
                                            placeholder="Address"
                                            type="text"
                                            @blur="checkPOBoxOnBlur"
                                            required
                                        >
                                    </div>
                                    <div class="apt-field">
                                        <input
                                            class="tf_textfield-3 w-input"
                                            maxlength="256"
                                            v-model="addressForm.address_line_2"
                                            name="Apt-2"
                                            placeholder="Apt #"
                                            type="text"
                                        >
                                    </div>
                                </div>
                                <div class="address-form-row">
                                    <div class="city-field">
                                        <input
                                            v-model="addressForm.city"
                                            class="tf_textfield-3 w-input"
                                            placeholder="City"
                                            required
                                        />
                                    </div>
                                    <div class="state-field">
                                        <select
                                            name="State"
                                            required
                                            v-model="addressForm.state"
                                            class="tf_textfield-3 w-input"
                                        >
                                            <option value="" disabled>State</option>
                                            <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }} - {{ value }}</option>
                                        </select>
                                    </div>
                                    <div class="zip-field">
                                        <input
                                            v-model="addressForm.zip"
                                            placeholder="ZIP Code"
                                            class="tf_textfield-3 w-input"
                                            maxlength="5"
                                            pattern="[0-9]{5}"
                                            inputmode="numeric"
                                            @input="validateZip"
                                            required
                                        />
                                    </div>
                                </div>
                                <input
                                    type="submit"
                                    class="form-button w-button"
                                    :value="validatingAddress ? 'Verifying...' : 'Verify and Save'"
                                    :disabled="validatingAddress"
                                >

                                <div v-if="showSuccess" class="success-message">
                                    <div>Address verified and saved successfully! Redirecting...</div>
                                </div>

                                <ErrorMessage
                                    :message="errorMessage"
                                    @dismiss="clearError"
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div style="height:280px"></div>
    </div>
</template>

<script>
import ErrorMessage from '../WeightLoss/ErrorMessage.vue';
import state from "@/utils/state.json";

export default {
    name: 'VerifyAddress',
    props: ['baseUrl'],
    components: {
        ErrorMessage
    },
    data() {
        return {
            errorMessage: '',
            loadingAddress: false,
            validatingAddress: false,
            showSuccess: false,
            showSuggestions: false,
            suggestedAddress: null,
            addressForm: {
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zip: ''
            },
            allState: state
        }
    },
    methods: {
        clearError() {
            this.errorMessage = '';
        },

        validateZip(event) {
            // Only allow numbers in zip code
            this.addressForm.zip = event.target.value.replace(/\D/g, '').slice(0, 5);
        },

        isPOBoxAddress() {
            // Comprehensive PO Box pattern detection
            const addressLine1 = this.addressForm.address_line_1.toUpperCase().replace(/[.\s]/g, '');
            const addressLine2 = this.addressForm.address_line_2.toUpperCase().replace(/[.\s]/g, '');

            // Common PO Box patterns
            const poBoxPatterns = [
                /\bP\s*O\s*BOX\b/i,           // PO BOX, P.O. BOX, P O BOX
                /\bPOBOX\b/i,                 // POBOX (no spaces)
                /\bPOB\b/i,                   // POB
                /\bPOSTOFFICEBOX\b/i,         // POST OFFICE BOX
                /\bP\.?\s*O\.?\s*B/i,         // P.O.B, POB
                /\bBOX\s*\d+/i,               // BOX followed by number
                /^BOX\b/i,                    // Starts with BOX
                /\bPMB\s*\d+/i,               // Private Mail Box
                /\bLOCK\s*BOX/i,              // LOCK BOX
                /\bBIN\s*\d+/i,               // BIN number
                /\bHC\s*\d+\s*BOX/i,          // HC (Highway Contract) BOX
                /\bRR\s*\d+\s*BOX/i,          // RR (Rural Route) BOX
                /\bRURALROUTE/i,              // RURAL ROUTE
                /\bHIGHWAYCONTRACT/i          // HIGHWAY CONTRACT
            ];

            // Check both address lines
            const combinedAddress = addressLine1 + ' ' + addressLine2;

            return poBoxPatterns.some(pattern => pattern.test(combinedAddress));
        },

        checkPOBoxOnBlur() {
            // Clear any existing error first
            this.errorMessage = '';

            // Check if it's a PO Box and show immediate feedback
            if (this.isPOBoxAddress()) {
                this.errorMessage = 'Our shipping partners FedEx and USPS do not deliver to PO Box addresses. Please provide a physical street address.';
            }
        },

        async fetchAddress() {
            this.loadingAddress = true;
            this.errorMessage = '';

            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/ship-address`);

                if (response.data && response.data.shipping) {
                    const shipping = response.data.shipping;
                    this.addressForm.address_line_1 = shipping.address_line_1 || '';
                    this.addressForm.address_line_2 = shipping.address_line_2 || '';
                    this.addressForm.city = shipping.city || '';
                    this.addressForm.state = shipping.state || '';
                    this.addressForm.zip = shipping.zip || '';
                }
            } catch (error) {
                console.error('Error fetching address:', error);
                this.errorMessage = 'Unable to load address. Please enter your address below.';
            } finally {
                this.loadingAddress = false;
            }
        },

        async validateAndSaveAddress() {
            this.validatingAddress = true;
            this.errorMessage = '';

            // First, check for PO Box patterns in the address
            if (this.isPOBoxAddress()) {
                this.errorMessage = 'Our shipping partners FedEx and USPS do not deliver to PO Box addresses. Please provide a physical street address.';
                this.validatingAddress = false;
                return;
            }

            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/address/validate`, {
                    address_line_1: this.addressForm.address_line_1,
                    address_line_2: this.addressForm.address_line_2,
                    city: this.addressForm.city,
                    state: this.addressForm.state,
                    zip: this.addressForm.zip
                });

                if (response.data) {
                    // Check if it's a PO Box from the API response
                    if (response.data.addressType && response.data.addressType.isPOBox) {
                        this.errorMessage = 'Our shipping partners FedEx and USPS do not deliver to PO Box addresses. Please provide a physical street address.';
                        this.validatingAddress = false;
                        return;
                    }

                    // Check if there are suggestions (even if valid is false)
                    if (response.data.suggestions) {
                        const suggestions = response.data.suggestions;

                        // Check if suggestions differ from what user entered
                        const hasDifferences =
                            suggestions.address_line_1.toUpperCase() !== this.addressForm.address_line_1.toUpperCase() ||
                            suggestions.city.toUpperCase() !== this.addressForm.city.toUpperCase() ||
                            suggestions.state.toUpperCase() !== this.addressForm.state.toUpperCase() ||
                            suggestions.zip !== this.addressForm.zip;

                        if (hasDifferences) {
                            // Show suggestions to user for confirmation
                            this.suggestedAddress = suggestions;
                            this.showSuggestions = true;
                            this.validatingAddress = false;
                            return;
                        }
                    }

                    // Check if address is valid
                    if (response.data.valid) {
                        // Address is valid with no changes needed, proceed to save
                        await this.saveAddress(this.addressForm);
                    } else {
                        // No suggestions and invalid address
                        this.errorMessage = response.data?.message || 'Address verification failed. Please check your address and try again.';
                    }
                } else {
                    this.errorMessage = 'Address verification failed. Please check your address and try again.';
                }
            } catch (error) {
                console.error('Error validating address:', error);
                this.errorMessage = error.response?.data?.error || error.response?.data?.message || 'Failed to validate address. Please try again.';
            } finally {
                this.validatingAddress = false;
            }
        },

        async acceptSuggestion() {
            // Use the suggested address
            await this.saveAddress(this.suggestedAddress);
        },

        editAddress() {
            // Hide suggestions and let user edit
            this.showSuggestions = false;
            this.suggestedAddress = null;
        },

        async saveAddress(addressData) {
            this.validatingAddress = true;
            this.errorMessage = '';

            try {
                // Save the verified address to backend
                const response = await this.$axios.post(`${this.baseUrl}/api/ship-address`, {
                    address_line_1: addressData.address_line_1,
                    address_line_2: addressData.address_line_2,
                    city: addressData.city,
                    state: addressData.state,
                    zip: addressData.zip
                });

                if (response.data.status === 'success') {
                    this.showSuccess = true;
                    this.showSuggestions = false;

                    // Redirect to home after a short delay
                    setTimeout(() => {
                        this.$router.push({ name: 'HomePage' });
                    }, 1500);
                } else {
                    this.errorMessage = 'Failed to save address. Please try again.';
                }
            } catch (error) {
                console.error('Error saving address:', error);
                this.errorMessage = error.response?.data?.error || 'Failed to save address. Please try again.';
            } finally {
                this.validatingAddress = false;
            }
        }
    },
    mounted() {
        this.fetchAddress();
    }
}
</script>

<style scoped>
.error-message {
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 10px;
    background-color: #FEE2E2;
    border: 1px solid #FCA5A5;
    color: #DC2626;
    border-radius: 4px;
    font-size: 14px;
}

.address-form-row {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    align-items: center;
}

.address-field {
    flex: 2;
}

.apt-field {
    flex: 1;
}

.city-field {
    flex: 1;
}

.state-field {
    flex: 1;
}

.zip-field {
    flex: 1;
}

.success-message {
    margin-top: 10px;
    padding: 10px;
    background-color: #D1FAE5;
    border: 1px solid #A7F3D0;
    color: #059669;
    border-radius: 4px;
    font-size: 14px;
}

.address-suggestions {
    background-color: #FEF3C7;
    border: 2px solid #F59E0B;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
}

.suggestion-header {
    font-weight: bold;
    margin-bottom: 20px;
    color: #92400E;
    font-size: 16px;
}

.comparison-container {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.address-column {
    flex: 1;
    background-color: white;
    border-radius: 6px;
    padding: 15px;
    border: 1px solid #E5E7EB;
}

.column-title {
    font-weight: 600;
    margin-bottom: 10px;
    color: #374151;
    font-size: 14px;
}

.address-display {
    line-height: 1.6;
    color: #6B7280;
}

.address-display.suggested {
    color: #059669;
    font-weight: 500;
}

.button-group {
    display: flex;
    gap: 15px;
    margin-top: 20px;
    flex-wrap: wrap;
}

.form-button.secondary {
    background-color: transparent;
    border: 1px solid #3B82F6;
    color: #3B82F6;
}

.form-button.secondary:hover {
    background-color: #EFF6FF;
}

@media only screen and (max-width: 767px) {
    .questions-div {
        width: 80%;
        padding: 50px 0% 80px;
        margin: 0 auto !important;
    }

    .comparison-container {
        flex-direction: column;
        gap: 15px;
    }

    .button-group {
        flex-direction: column;
    }

    .address-form-row {
        flex-direction: row;
        gap: 8px;
        margin-bottom: 12px;
    }

    .address-field {
        flex: 2;
    }

    .apt-field {
        flex: 1;
    }

    .city-field {
        flex: 1;
    }

    .state-field {
        flex: 1;
    }

    .zip-field {
        flex: 1;
    }

    .address-form-row input,
    .address-form-row select {
        font-size: 14px;
        padding: 8px 6px;
    }
}

@media only screen and (max-width: 767px) {
    .questions-div[data-v-20d89714] {
        width: 93%;
        padding: 50px 0% 80px;
        margin: 0 auto !important;
    }
}
</style>
